import { SurveyJSON } from "Survey/types"

const json: SurveyJSON = {
  success: 'Færdig! Bemærk at du kun hører fra os, hvis vi er interesserede, så ikke vent på os.',
  allowNewCustomer: true,
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "Email adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: 'Velkommen til Revisor1s Afstemningstest for Reconciliation checked opgaver. Testen består af 57 spørgsmål. Skriv dit svar under hvert spørgsmål. Når du er færdig, trykker du blot på ‘færdig’ knappen, og så modtager vi automatisk dine svar. God fornøjelse!',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn',
      required: true,
      placeholder: 'Jens Jensen'
    },
    {
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: true,
      placeholder: 'email@email.com'
    },
    {
      type: 'input',
      name: 'hvad_skal_du_gøre_før_du_starter_på_reconciliation_checked',
      title: 'Hvad skal du gøre før du starter på reconciliation_checked?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvad_er_formålet_med_tasken_reconciliation_checked',
      title: 'Hvad er formålet med tasken "reconciliation_checked"?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvad_skal_du_gøre_hvis_der_er_mange_transaktioner_med_samme_mønster',
      title: 'Hvad skal du gøre, hvis der er mange transaktioner med samme mønster?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvad_gør_knappen_toggle_matches_i_reconciliation_php',
      title: 'Hvad gør knappen “Toggle Matches” i reconciliation.php?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'bilag_på_bilagsliste_indeholder_kontant_betalt_hvordan_håndteres_denne_oplysning',
      title: 'Bilag på bilagsliste indeholder “kontant betalt”. Hvordan håndteres denne oplysning?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvad_er_bankafstemning',
      title: 'Hvad er bankafstemning?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvordan_sikrer_du_kvalitet_i_reconciliation_checked_hvis_du_er_ny_i_rollen',
      title: 'Hvordan sikrer du kvalitet i reconciliation_checked, hvis du er ny i rollen?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_kontokort_fra_skattekontoen',
      title: 'Hvordan håndteres kontokort fra skattekontoen?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvad_betyder_det_at_banken_stemmer_i_bogføringen',
      title: 'Hvad betyder det, at banken “stemmer” i bogføringen?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_bilag_i_udenlandsk_valuta_som_har_betalingsdato_i_fremtiden_kurs_ukendt_dateret_den_sidste_dag_i_perioden_der_afstemmes_for',
      title: 'Hvordan håndteres bilag i udenlandsk valuta som har betalingsdato i fremtiden (kurs ukendt), dateret den sidste dag i perioden der afstemmes for?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'der_afstemmes_for_måneder_bilagslisten_indeholder_mange_bilag_fra_samme_leverandør_banklisten_indeholder_kun_samlet_betaling_pr_måned_hvordan_ved_du_hvilke_bilag_der_bør_matches_til_de_enkelte_samlet_betaling_typisk_ved_køb_på_konto_hos_leverandør',
      title: 'Der afstemmes for 6 måneder. Bilagslisten indeholder mange bilag fra samme leverandør. Banklisten indeholder kun 1 samlet betaling pr. Måned. Hvordan ved du hvilke bilag der bør matches til de enkelte samlet betaling (typisk ved køb på konto hos leverandør)?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvad_er_sammenhængen_mellem_bankafstemning_og_årsregnskabet',
      title: 'Hvad er sammenhængen mellem bankafstemning og årsregnskabet?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvordan_afsluttes_tasken_korrekt',
      title: 'Hvordan afsluttes tasken korrekt?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvor_findes_information_om_kundens_moms_bil_og_personaleforhold',
      title: 'Hvor findes information om kundens moms, bil og personaleforhold?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_kreditorbilag_udgiftsbilag_hvis_fortegn_er_forkert',
      title: 'Hvordan håndteres kreditorbilag (udgiftsbilag) hvis fortegn er forkert?',
      required: true,
    },
    {
      type: 'input',
      name: 'bankliste_indeholder_udbetalinger_med_teksten_løn_på_kr_ingen_bilag_der_matcher_banktransaktionen_hvordan_forudfyldes_denne_banktransaktion',
      title: 'Bankliste indeholder udbetalinger med teksten “løn” på 15.000 kr. Ingen bilag der matcher banktransaktionen. Hvordan forudfyldes denne banktransaktion?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_vides_det_om_kunden_er_momspligtig',
      title: 'Hvordan vides det om kunden er momspligtig?',
      required: true,
    },
    {
      type: 'input',
      name: 'bilagslisten_indeholder_flere_kreditorbilag_fra_samme_leverandør_og_et_par_betalingstransaktioner_på_banklisten_hvordan_kan_de_eventuelt_matches',
      title: 'Bilagslisten indeholder flere kreditorbilag fra samme leverandør og et par betalingstransaktioner på banklisten. Hvordan kan de eventuelt matches?',
      required: true,
    },
    {
      type: 'input',
      name: 'bilag_fra_tidligere_og_lukkede_perioder_fremgår_af_bilagsliste_hvordan_håndteres_disse',
      title: 'Bilag fra tidligere og lukkede perioder, fremgår af bilagsliste. Hvordan håndteres disse?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvorfor_er_bilag_vigtige',
      title: 'Hvorfor er bilag vigtige?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_betyder_dobbelt_bogføring_i_denne_sammenhæng_og_hvordan_opdages_det',
      title: 'Hvad betyder “dobbelt bogføring” i denne sammenhæng, og hvordan opdages det?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvilke_typiske_fejl_opdages_ved_bankafstemning',
      title: 'Hvilke typiske fejl opdages ved bankafstemning?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_er_en_mellemregningskonto_og_hvordan_kan_den_bruges_i_forbindelse_med_afstemning',
      title: 'Hvad er en mellemregningskonto, og hvordan kan den bruges i forbindelse med afstemning?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_kvitteringer_hvor_det_af_kvitteringen_fremgår_at_der_er_betalt_kontant',
      title: 'Hvordan håndteres kvitteringer, hvor det af kvitteringen fremgår at der er betalt kontant?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_er_typiske_årsager_til_at_banken_ikke_stemmer',
      title: 'Hvad er typiske årsager til at banken ikke stemmer?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_gør_du_hvis_du_finder_en_banktransaktion_uden_matchende_bilag',
      title: 'Hvad gør du, hvis du finder en banktransaktion uden matchende bilag?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_kan_bankafstemning_opdage_svindel',
      title: 'Hvordan kan bankafstemning opdage svindel?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'et_bilag_er_fejlagtigt_tastet_som_dkk_i_systemet_men_viser_eur_på_faktisk_bilag_hvordan_rettes_denne_fejl',
      title: 'Et bilag er fejlagtigt tastet som DKK i systemet, men viser EUR på faktisk bilag. Hvordan rettes denne fejl?',
      required: true,
     
    },
    {
      type: 'input',
      name: 'hvad_er_en_mangelliste',
      title: 'Hvad er en mangelliste?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_er_en_sekundærbilag',
      title: 'Hvad er en sekundærbilag?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_salgsrapporter_i_bilagslisten',
      title: 'Hvordan håndteres salgsrapporter i bilagslisten?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_betyder_en_rød_streg_i_reconciliation_vinduet',
      title: 'Hvad betyder en rød streg i reconciliation-vinduet?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvorfor_er_korrekt_afstemning_afgørende_for_at_undgå_problemer_når_moms_eller_årsregnskab_skal_laves',
      title: 'Hvorfor er korrekt afstemning afgørende for at undgå problemer når moms eller årsregnskab skal laves?',
      required: true,
    },
    {
      type: 'input',
      name: 'er_der_konsekvenser_hvis_der_ikke_laves_bankafstemning',
      title: 'Er der konsekvenser, hvis der ikke laves bankafstemning?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_er_forskellen_på_en_bogført_saldo_og_en_disponibel_saldo_i_banken',
      title: 'Hvad er forskellen på en “bogført saldo” og en “disponibel saldo” i banken?',
      required: true,
    },
    {
      type: 'input',
      name: 'på_bilagsliste_findes_bilag_dateret_ultimo_perioden_og_med_betalingsfrist_i_ny_periode_hvordan_forudfyldes_disse_bilag',
      title: 'På bilagsliste findes bilag dateret ultimo perioden og med betalingsfrist i ny periode. Hvordan forudfyldes disse bilag?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_er_interbank_transaktioner',
      title: 'Hvad er interbank-transaktioner?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_prioriterer_du_bilag_og_banktransaktioner_hvis_der_er_mange_umatchede_poster',
      title: 'Hvordan prioriterer du bilag og banktransaktioner, hvis der er mange umatchede poster?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_undgår_du_dobbeltbogføring_ved_sekundærbilag',
      title: 'Hvordan undgår du dobbeltbogføring ved sekundærbilag?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_bilag_der_er_delvist_betalt_via_bank_og_delvist_kontant',
      title: 'Hvordan håndteres bilag, der er delvist betalt via bank og delvist kontant?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_kan_man_sortere_på_i_reconciliation_vægten',
      title: 'Hvad kan man sortere på i reconciliation/“vægten”?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_kan_du_identificere_om_en_banktransaktion_er_en_interbank_overførsel',
      title: 'Hvordan kan du identificere om en banktransaktion er en interbank-overførsel?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_dagligvarebutikkers_kvitteringer_som_ikke_findes_i_banken',
      title: 'Hvordan håndteres dagligvarebutikkers kvitteringer, som ikke findes i banken?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_sikrer_du_at_en_kreditnota_fra_en_leverandør_behandles_korrekt_i_afstemning',
      title: 'Hvordan sikrer du, at en kreditnota fra en leverandør behandles korrekt i afstemning?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvis_du_har_en_difference_der_skyldes_forkert_momsbehandling_hvordan_håndterer_du_det',
      title: 'Hvis du har en difference, der skyldes forkert momsbehandling, hvordan håndterer du det?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_kan_være_årsagen_til_at_en_kundeindbetaling_ikke_kan_matches_med_en_faktura',
      title: 'Hvad kan være årsagen til, at en kundeindbetaling ikke kan matches med en faktura?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_betyder_en_grøn_rød_og_blå_streg_i_reconciliation_php',
      title: 'Hvad betyder en grøn, rød og blå streg i reconciliation.php?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_bilag_der_er_betalt_efter_regnskabsperioden',
      title: 'Hvordan håndteres bilag, der er betalt efter regnskabsperioden?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_gør_du_hvis_en_banktransaktion_ikke_kan_matches_med_et_bilag',
      title: 'Hvad gør du, hvis en banktransaktion ikke kan matches med et bilag?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvornår_må_du_tømme_mangellisterne',
      title: 'Hvornår må du tømme mangellisterne?',
      required: true,
      
    },
    {
      type: 'input',
      name: 'hvordan_vides_det_om_der_er_moms_på_kundens_husleje',
      title: 'Hvordan vides det om der er moms på kundens husleje?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_bilag_der_er_sendt_ind_uden_dato',
      title: 'Hvordan håndteres bilag, der er sendt ind uden dato?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvad_betyder_bankafstemning',
      title: 'Hvad betyder bankafstemning?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvorfor_er_bankafstemning_vigtig',
      title: 'Hvorfor er bankafstemning vigtig?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_sikrer_du_at_du_ikke_overser_bilag_der_er_relevante_for_banktransaktioner',
      title: 'Hvordan sikrer du, at du ikke overser bilag, der er relevante for banktransaktioner?',
      required: true,
    },
    {
      type: 'input',
      name: 'hvordan_håndteres_bilag_med_utydelige_eller_manglende_beskrivelser',
      title: 'Hvordan håndteres bilag med utydelige eller manglende beskrivelser?',
      required: true,
    },
    {
      type: 'custom',
      name: 'submit',
      html: '<blockquote>Tryk "indsend" for at sende os svarene.</blockquote>',
      buttons: ['submit']
    }
  ]
}

export default json
